/**
 * An icon per module.
 *
 * The server names the module and the colour it wears; the icon stays here
 * because it is the one part of that answer that belongs to a particular icon
 * set. A backend returning `"pi pi-sparkles"` would be describing PrimeIcons,
 * and the next thing rendering a project — an export, a slide, a mobile view —
 * would have to translate it back.
 *
 * The fallback is deliberate rather than defensive: a module added on the
 * server shows up immediately with a neutral icon instead of a blank space or a
 * crash, and picking a better one is a one-line follow-up.
 */
const ICONS: Record<string, string> = {
  ai: 'pi pi-sparkles',
  se: 'pi pi-shield',
  uh: 'pi pi-sitemap',
};

export const moduleIcon = (key: string): string => ICONS[key] ?? 'pi pi-database';

export default moduleIcon;
